import { render } from "./ModalAddPlano.vue?vue&type=template&id=2f40b40a"
import script from "./ModalAddPlano.vue?vue&type=script&lang=js"
export * from "./ModalAddPlano.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__